export enum MealId {
  AllInclusive = 1,
  Breakfast = 2,
  FullBoard = 3,
  FullBoardWithDrinks = 4,
  HalfBoard = 5,
  HalfBoardWithDrinks = 6,
  RoomOnly = 7,
  UltraAllInclusive = 8,
  Program = 9,
  BreakfastAndLunch = 10,
  AllInclusiveNoAlcohol = 11,
  Lunch = 12,
  Dinner = 13,
  RoomOnlyWithTreatment = 14,
  BreakfastWithTreatment = 15,
  HalfBoardWithTreatment = 16,
  FullBoardWithTreatment = 17,
}

export interface MealData {
  id: number;
  name: string;
  code: string;
}
